import { Loader2 } from "lucide-react";
import { cn } from "../../lib/cn";

export function Spinner({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <Loader2
      aria-hidden
      className={cn("animate-spin text-current", className)}
      width={size}
      height={size}
    />
  );
}
